import { createSlice } from "@reduxjs/toolkit";
import { addCompanyDetails, addJobPostByHireTalent, getJobPostData, hireTalentSignUp } from "../actions/authAction";

const initialState = {
  isLoading: false,
  subLoading: false,
  isHireTalentModal: false,
  pagename: "signup",
  jobPostList: {},
  JobHeader: [
    "S.No.",
    "Job Title",
    "Category",
    "Status",
    "Applicant",
    "Location",
    "Action"
  ],
};

const hireTalentSlice = createSlice({
  name: "hire-talent",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.pagename = action.payload;
    },
    setIsHireTalentModal: (state, action) => {
      state.isHireTalentModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    // hire-talent-sign-up
    builder.addCase(hireTalentSignUp.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(hireTalentSignUp.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(hireTalentSignUp.rejected, (state, action) => {
      state.subLoading = false;
    });
    // add-company-details
    builder.addCase(addCompanyDetails.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(addCompanyDetails.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(addCompanyDetails.rejected, (state, action) => {
      state.subLoading = false;
    });

    // addJobPostByHireTalent
    builder.addCase(addJobPostByHireTalent.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(addJobPostByHireTalent.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(addJobPostByHireTalent.rejected, (state, action) => {
      state.subLoading = false;
    });

    // getJobPostData
    builder.addCase(getJobPostData.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(getJobPostData.fulfilled, (state, action) => {
      const { data } = action.payload;
      // state.jobPostList = data || [];
      state.subLoading = false;
      const grouped = Object?.groupBy(data, (p) => p?.status);
      state.jobPostList = {
        all: data,
        ...grouped,
      };
    });
    builder.addCase(getJobPostData.rejected, (state, action) => {
      state.subLoading = false;
    });
  },
});

export default hireTalentSlice.reducer;
export const { setPage, setIsHireTalentModal } = hireTalentSlice.actions;
